import { render } from "./FinderFilter.vue?vue&type=template&id=63e64333&ts=true"
import script from "./FinderFilter.vue?vue&type=script&lang=ts"
export * from "./FinderFilter.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/witteveenbos/witteveenbos-light-modules/corporate-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__